import { SingleSelectGroup } from '@doordash/component-select-group';
import Toggle from '@doordash/component-toggle';
import { StackChildren, Text, Icon, InlineChildren, } from '@doordash/design-language';
import { InputContainer } from './budget_form_styles';
import { TextField } from '@doordash/component-fields';
import Button from '@doordash/component-button';
import Tooltip from '@doordash/component-tooltip';
import * as React from 'react';
import { EXPENSE_CODE_SELECT, EXPENSE_CODE_SELECT_UPDATED, EXPENSE_CODE_MODE_MAPPING, } from '../budget_helper';
export var ExpenseCodeSelector = function (_a) {
    var initialValues = _a.initialValues, values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue, isEnforcedListEnabled = _a.isEnforcedListEnabled;
    var singleSelectGroupOptions = isEnforcedListEnabled
        ? EXPENSE_CODE_SELECT_UPDATED
        : EXPENSE_CODE_SELECT;
    var getSelectGroupIndex = function (val) {
        var mode = Object.keys(EXPENSE_CODE_MODE_MAPPING).find(function (key) { return EXPENSE_CODE_MODE_MAPPING[key] === val; });
        return val ? singleSelectGroupOptions.indexOf(mode) : 0;
    };
    var initialExpenseCodeMode = initialValues.expenseCodeEnforcementMode;
    var handleSetExpenseCodeMode = function (isExpenseCodeModeOn) {
        setFieldValue('budgetExpenseCodeMode', isExpenseCodeModeOn);
        if (isExpenseCodeModeOn) {
            // on
            if (initialExpenseCodeMode > 0) {
                setFieldValue('expenseCodeEnforcementMode', initialExpenseCodeMode);
            }
            else {
                setFieldValue('expenseCodeEnforcementMode', EXPENSE_CODE_MODE_MAPPING.Required);
            }
        }
        else {
            // off
            setFieldValue('expenseCodeEnforcementMode', EXPENSE_CODE_MODE_MAPPING.NotRequired);
        }
    };
    return (React.createElement(StackChildren, { size: StackChildren.Sizes.Small },
        React.createElement(Toggle, { label: "Member should enter expense code to use this budget", type: Toggle.Types.Toggle, isSelected: values.budgetExpenseCodeMode, onChange: handleSetExpenseCodeMode, renderLabel: function (_a) {
                var htmlFor = _a.htmlFor, label = _a.label;
                return (React.createElement("label", { htmlFor: htmlFor },
                    React.createElement(Text, { color: Text.Colors.TextPrimary, children: label, styles: Text.Styles.Label2Emphasis })));
            } }),
        values.budgetExpenseCodeMode ? (React.createElement(StackChildren, null,
            React.createElement(Text, { styles: Text.Styles.Label2 }, "Entering expense code is"),
            React.createElement(InputContainer, { size: "large" },
                React.createElement(SingleSelectGroup, { accessibilityLabel: 'Expense Code Options', type: SingleSelectGroup.Types.PrimaryPill, defaultSelectedIndex: getSelectGroupIndex(values.expenseCodeEnforcementMode), options: singleSelectGroupOptions, onChange: function (selectedIndex) {
                        setFieldValue('expenseCodeEnforcementMode', EXPENSE_CODE_MODE_MAPPING[singleSelectGroupOptions[selectedIndex]]);
                    } })),
            values.expenseCodeEnforcementMode === 4 ? (React.createElement(StackChildren, null,
                React.createElement(InlineChildren, { size: InlineChildren.Sizes.XSmall, alignItems: InlineChildren.Alignment.Center },
                    React.createElement(Text, { styles: Text.Styles.Label2Emphasis }, "Expense Code List"),
                    React.createElement(Tooltip, { size: Tooltip.Sizes.Small, content: "Employees will be required to enter an expense code from this list at checkout" }, function (_a) {
                        var describedBy = _a.describedBy;
                        return (React.createElement(Button, { accessibilityDescribedBy: describedBy, type: Button.Types.FlatSecondary, padding: Button.Padding.None },
                            React.createElement(Icon, { type: Icon.Types.InfoCircleLine, color: Icon.Colors.SystemGrey60 })));
                    })),
                React.createElement(InputContainer, { size: "large" },
                    React.createElement(TextField, { label: 'Expense Code Valid Values', value: values.expenseCodeValidValues, onChange: function (value) {
                            return setFieldValue('expenseCodeValidValues', value);
                        }, placeholder: "Enter expense codes separated by commas", isMultiline: 1, error: errors.expenseCodeValidValues })))) : (''))) : ('')));
};
export default ExpenseCodeSelector;
